import { useEffect, useState } from "react";
import { Parallax } from "react-parallax";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // ← uusi
import HeaderImage1 from "../../assets/banner darkmode.jpg";
import HeaderImage2 from "../../assets/banner darkmode.jpg";
import HeaderImage3 from "../../assets/banner darkmode.jpg";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";

const slides = [
  {
    image: HeaderImage1,
    title: "Tarvitsetko verkkosivut bändillesi tai yrityksellesi?",
    description:
      "Modernit, responsiiviset ja näyttävät verkkosivut, jotka erottuvat massasta ja tukevat brändiäsi.",
    buttonText: "Ota yhteyttä",
    link: "/tee-varaus",
  },
  {
    image: HeaderImage2,
    title: "Osta mainostilaa",
    description:
      "Laajenna näkyvyyttäsi mainostilamme avulla ja tavoita uusia asiakkaita helposti. Näkyvä markkinointi, pysyvä mielikuva.",
    buttonText: "Osta mainostilaa",
    link: "/tee-varaus",
  },
  {
    image: HeaderImage3,
    title: "Premium vai Basic?",
    description:
      "Näy enemmän, saa arvosteluja ja houkuttele asiakkaita tehokkaammin – katso vaihtoehdot ja hyödyt.",
    buttonText: "Liity mukaan",
    link: "/liity",
  },
];

const WebDesignBanner = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);    
    return () => clearInterval(intervalId);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide((index + slides.length) % slides.length); // wrap-around
  };

  const current = slides[currentSlide];

  return (
    <header className="relative pt-10 p-0">
      <Parallax bgImage={current.image} strength={1500}>
        <div className="absolute inset-0 bg-black opacity-40" />

        <div className="relative flex flex-col items-center justify-center h-[250px] p-4">
          {/* ← Nuolinapit vasen/oikea */}
          <button
            onClick={() => goToSlide(currentSlide - 1)}
            className="absolute left-4 top-[60%] text-white z-20 bg-black bg-opacity-50 p-2 rounded-full hover:bg-opacity-80"
            aria-label="Edellinen"
          >
            <FaChevronLeft />
          </button>
          <button
            onClick={() => goToSlide(currentSlide + 1)}
            className="absolute right-4 top-[60%] text-white z-20 bg-black bg-opacity-50 p-2 rounded-full hover:bg-opacity-80"
            aria-label="Seuraava"
          >
            <FaChevronRight />
          </button>

          <AnimatePresence mode="wait">
            <motion.div
              key={currentSlide}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8 }}
              className="relative z-10 text-center flex flex-col items-center justify-center h-full"
            >
              <h3 className="font-customFont2 text-shadow-xxl text-primary text-2xl xxsm:text-xl xxxsm:text-xl font-normal leading-tight pt-4 mt-4">
                {current.title}
              </h3>
              <p className="font-customFont1 text-shadow-xxl text-primary text-sm">
                {current.description}
              </p>
              <div className="flex justify-center mt-2">
                <ResponsiveButton
                  onClick={() => navigate(current.link)}
                  className="h-8 w-36 border-2 border-transparent dark:bg-primary dark:hover:border-white dark:hover:opacity-90 bg-darkest hover:border-white hover:opacity-90 text-darkest font-customFont1 font-normal text-sm overflow-hidden transform transition duration-300 ease-in flex justify-center items-center rounded-full"
                  style={{ boxShadow: "0 0 20px 3px rgba(255, 255, 255, 0.5)" }}
                >
                  {current.buttonText}
                </ResponsiveButton>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </Parallax>
    </header>
  );
};

export default WebDesignBanner;
